import { memoAll } from '../../../CodesForFoundation';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { component, property } from '../../../concepts/objects';
import { memoUsing } from '../../../concepts/objects/MemoUsing';
import { FixedRectangular } from '../../canvas/entities/FixedRectangular';
import { Physical, PotentialInteraction, TransformHints } from '../../canvas/entities/Physical';
import { Snappable } from '../../canvas/entities/Snappable';
import { counterDecrement, counterIncrement, counterSet } from './CounterCommands';
import { CounterLayout } from './CounterLayout';
import { counterPropertyLayout } from './CounterPropertyLayout';

const invocation = defineCommand(
    'counterInteraction',
    null,
    (cc, [id, region]: [string, string?]) => {
        if (region === 'inc') {
            cc.dispatch(counterIncrement, [id]);
        }
        else if (region === 'dec') {
            cc.dispatch(counterDecrement, [id]);
        }
        else if (region === 'reset') {
            cc.dispatch(counterSet, [id, 0]);
        }
    },
    [],
);

const jukeboxDef = {
    name: 'Counter',
    implements: [Physical, Snappable],
    invocation,
    propertyLayout: counterPropertyLayout,
};

@component(jukeboxDef)
export class Counter extends FixedRectangular implements Snappable {

    @property({ type: 'number', default: 180 })
    public width!: number;

    @property({ type: 'number', default: 120 })
    public height!: number;

    @property({ type: 'string', default: '#d11a59' })
    public color!: string;

    @property({ type: 'number', default: 0 })
    public value!: number;

    @memoUsing('width', 'height')
    public get layout(): CounterLayout {
        return CounterLayout(this);
    }

    public get boundary() {
        return true;
    }

    public get shouldSnap() {
        return true;
    }

    @memoAll()
    public queryTransformHints(): TransformHints {
        return {
            scaleX: false,
            scaleY: false,
            rotate: false,
            translate: true,
            visible: true,
        };
    }

    public testInteraction({ type, mpt }: PotentialInteraction, _force?: boolean, _selected?: boolean): [boolean, string] {
        const { dec, reset, inc } = this.layout;
        const rpt = this.toRelative(mpt);
        if (this.localBounds.contains(rpt)) {
            if (type === 'invoke') {
                if (dec.contains(rpt)) {
                    return [true, 'dec'];
                }
                else if (reset.contains(rpt)) {
                    return [true, 'reset'];
                }
                else if (inc.contains(rpt)) {
                    return [true, 'inc'];
                }
            }
            else {
                return [true, 'default'];
            }
        }
        return [false, 'none'];
    }
}
